import { defHttp } from '/@/utils/http'

export function organizationsListApi(params?: Recordable) {
  return defHttp.get({ url: '/api/organizations', params })
}

export function organizationsDetailApi(slug: string) {
  return defHttp.get({ url: `/api/organizations/${slug}` })
}

export function organizationsLicenseStatsApi(slug: string) {
  return defHttp.get({ url: `/api/organizations/${slug}/license-stats` })
}

export function organizationLicensesSummaryApi(slug: string) {
  return defHttp.get({ url: `/api/organizations/${slug}/license-summary` })
}

export function licenseDetailApi(slug: string) {
  return defHttp.get({ url: `/api/licenses/${slug}` })
}
